export const BASE_URL = window.location.origin + import.meta.env.BASE_URL;
